import { useEffect } from "react";
import { useTheme } from "./contexts/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Section components
import Hero from "./components/sections/Hero";
import TrustedBy from "./components/sections/TrustedBy";
import APIFeatures from "./components/sections/APIFeatures";
import LiquiditySources from "./components/sections/LiquiditySources";
import DiscoverApp from "./components/sections/DiscoverApp";
import ForDevelopers from "./components/sections/ForDevelopers";
import StrategicPartners from "./components/sections/StrategicPartners";
import Metrics from "./components/sections/Metrics";
import CTASection from "./components/sections/CTASection";
import FAQSection from "./components/sections/FAQSection";
import { track } from "./lib/analytics";

export default function App() {
  const { darkMode } = useTheme();

  // Track scroll depth
  useEffect(() => {
    const thresholds = [25, 50, 75, 90, 100];
    const reached = new Set();

    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;
      const percentage = scrollHeight > 0 ? Math.round((scrolled / scrollHeight) * 100) : 0;

      thresholds.forEach((threshold) => {
        if (percentage >= threshold && !reached.has(threshold)) {
          reached.add(threshold);
          
          // Find the current section at this scroll depth
          const sections = document.querySelectorAll('section[id]');
          let maxSection = 'unknown';
          sections.forEach((section) => {
            const rect = section.getBoundingClientRect();
            if (rect.top <= window.innerHeight / 2 && rect.bottom >= 0) {
              maxSection = section.id;
            }
          });

          track('scroll_depth_reached', {
            depth_pct: threshold,
            max_section: maxSection
          });
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`text-main-black ${darkMode ? 'dark bg-main-black' : 'bg-white'}`}>
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <Hero />

      {/* Trusted By / Partners Section */}
      <TrustedBy />

      {/* Liquidity Sources Section */}
      <LiquiditySources />

      {/* API Features Section */}
      <APIFeatures />

      {/* For Developers Section */}
      <ForDevelopers />

      {/* Strategic Partners Section */}
      <StrategicPartners />

      {/* Discover App Section */}
      <DiscoverApp />

      {/* Metrics Section */}
      <Metrics />

      {/* CTA Section */}
      <CTASection />

      {/* FAQ Section */}
      <FAQSection />

      {/* Footer */}
      <Footer />
    </div>
  );
}
